<div class="grid-container">

	<div class="basic-info-container">
		<ng-content select="app-details-toolbar-basic-info"></ng-content>
	</div>

	<div class="status-container">
		<ng-content select="app-details-toolbar-status"></ng-content>
	</div>

	<div class="additional-info-container">
		<ng-content select="app-details-toolbar-additional-info"></ng-content>
	</div>

	<div class="created-and-changed-info-container">
		<ng-content select="app-details-toolbar-created-and-modified-info"></ng-content>
	</div>

	<div class="actions-container">
		<ng-content select="app-details-toolbar-actions"></ng-content>
	</div>

</div>